import { SupportedLocation } from '@/modules/location/constants.ts';
import { type GetBreadcrumbRequestGender } from '@/modules/search/aliases';

export const MENS_DEPARTMENT_URL_KEY = 'mens';
export const WOMENS_DEPARTMENT_URL_KEY = 'womens';
export const KIDS_DEPARTMENT_URL_KEY = 'kids';
export const kidswearId = 'kidswear';
export const everythingElseId = 'everything-else';

export const GENDER_TO_DEPARTMENT_ID: Record<string, string> = {
  male: 'menswear',
  female: 'womenswear',
};

export const CATEGORY_PATH_TO_GENDER: Record<
  string,
  GetBreadcrumbRequestGender
> = {
  mens: 'male',
  womens: 'female',
};

export const DEPARTMENT_TO_GENDER: Record<string, string> = {
  menswear: 'male',
  womenswear: 'female',
};

export const GENDER_TO_CATEGORY_PATH: Record<string, string> = {
  male: 'mens',
  female: 'womens',
};

export const BUBBLE_NAV_LABELS: Record<string, string> = {
  [MENS_DEPARTMENT_URL_KEY]: `Men's Clothing`,
  [WOMENS_DEPARTMENT_URL_KEY]: `Women's Clothing`,
};

export const RESTRICTED_POPULAR_CATEGORY_NAMES = [
  'Other',
  'Lingerie',
  'Sets',
  'Underwear',
];
export const MAX_POPULAR_CATEGORIES = 7;
export const MAX_PREDICTED_CATEGORIES = 3;

export const BUBBLE_IMAGE_WIDTH = 200;

export function getWWCategoryBubblesConfig(locale?: string) {
  if (locale === SupportedLocation.AU || locale === SupportedLocation.NZ) {
    return [
      {
        label: 'Tops',
        url: 'category/womens/tops/',
        imgSrc: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/category/WW-Tops.jpeg`,
      },
      {
        label: 'Bottoms',
        url: 'category/womens/bottoms',
        imgSrc: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/category/WW-Bottoms.jpeg`,
      },
      {
        label: 'Dresses',
        url: 'category/womens/dresses/',
        imgSrc: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/category/WW-Dresses.jpeg`,
      },
      {
        label: 'Sneakers',
        url: 'category/womens/footwear/trainers/',
        imgSrc: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/category/WW-Sneakers.jpeg`,
      },
      {
        label: 'Outerwear',
        url: 'category/womens/outerwear/',
        imgSrc: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/category/WW-Outerwear.jpeg`,
      },
      {
        label: 'Accessories',
        url: 'category/womens/accessories/',
        imgSrc: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/category/WW-Accessories.jpeg`,
      },
    ];
  }

  return [
    {
      label: 'Tops',
      url: 'category/womens/tops/',
      imgSrc: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/category/WW-Tops-Autumn.jpg`,
    },
    {
      label:
        locale === SupportedLocation.US || locale === SupportedLocation.CA
          ? 'Pants'
          : 'Trousers',
      url: 'category/womens/bottoms',
      imgSrc: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/category/WW-Pants-Trousers-Autumn.jpg`,
    },
    {
      label: 'Outerwear',
      url: 'category/womens/outerwear/',
      imgSrc: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/category/WW-Outerwear-Autumn.jpg`,
    },
    {
      label: 'Boots',
      url: 'category/womens/footwear/boots/',
      imgSrc: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/category/WW-Boots-Autumn.jpg`,
    },
    {
      label: 'Dresses',
      url: 'category/womens/dresses/',
      imgSrc: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/category/WW-Dresses-Autumn.jpg`,
    },
    {
      label: 'Accessories',
      url: 'category/womens/accessories/',
      imgSrc: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/category/WW-Accessories-Autumn.jpg`,
    },
  ];
}

export function getMWCategoryBubblesConfig(locale?: string) {
  if (locale === SupportedLocation.AU || locale === SupportedLocation.NZ) {
    return [
      {
        label: 'T-Shirts',
        url: 'category/mens/tops/t-shirts/',
        imgSrc: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/category/MW-Tshirt.jpeg`,
      },
      {
        label: 'Shorts',
        url: 'category/mens/bottoms/shorts/',
        imgSrc: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/category/MW-Shorts.jpg`,
      },
      {
        label: 'Accessories',
        url: 'category/mens/accessories/',
        imgSrc: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/category/MW-Accessories.jpeg`,
      },
      {
        label: 'Sweaters',
        url: 'category/mens/tops/sweatshirts/',
        imgSrc: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/category/MW-jumpers-sweaters.jpg`,
      },
      {
        label: 'Sneakers',
        url: 'category/mens/footwear/trainers/',
        imgSrc: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/category/MW-Sneakers.jpeg`,
      },
      {
        label: 'Outerwear',
        url: 'category/mens/coats-jackets/',
        imgSrc: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/category/MW-Outerwear.jpeg`,
      },
    ];
  }

  return [
    {
      label: 'T-Shirts',
      url: 'category/mens/tops/t-shirts/',
      imgSrc: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/category/MW-Tshirt.jpeg`,
    },
    {
      label:
        locale === SupportedLocation.US || locale === SupportedLocation.CA
          ? 'Pants'
          : 'Trousers',
      url: 'category/mens/bottoms/bottoms/',
      imgSrc: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/category/MW-Pants-Trousers-Autumn.jpg`,
    },
    {
      label: 'Accessories',
      url: 'category/mens/accessories/',
      imgSrc: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/category/MW-Accessories.jpeg`,
    },
    {
      label: locale === SupportedLocation.GB ? 'Jumpers' : 'Sweaters',
      url: 'category/mens/tops/sweatshirts/',
      imgSrc: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/category/MW-jumpers-sweaters.jpg`,
    },
    {
      label: 'Boots',
      url: 'category/mens/footwear/boots/',
      imgSrc: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/category/MW-Boots-Autumn.jpg`,
    },
    {
      label: 'Outerwear',
      url: 'category/mens/coats-jackets/',
      imgSrc: `${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/category/MW-Outerwear.jpeg`,
    },
  ];
}

export function getBubbleNavConfigByDepartment(locale?: SupportedLocation) {
  return {
    [WOMENS_DEPARTMENT_URL_KEY]: getWWCategoryBubblesConfig(locale),
    [MENS_DEPARTMENT_URL_KEY]: getMWCategoryBubblesConfig(locale),
  };
}
